import React, {
  useContext, useEffect,
} from 'react';
import classnames from 'classnames';

import './styles.scss';
import { useTranslation } from '@common/hooks/translation';
import { RacingsContext } from '@racings/store/context';

export const ResultFilter = () => {
  const [racingState, setRacingsState] = useContext(RacingsContext);
  const { isYesterday } = racingState;
  const t = useTranslation();

  useEffect(() => {
    setRacingsState((old) => ({ ...old, isYesterday: true }));
  }, [setRacingsState]);

  const list = [
    {
      type: 'yesterday',
      label: 'Yesterday',
      value: true,
    },
    {
      type: 'today',
      label: 'Today',
      value: false,
    },
  ];

  return (
    <div className="date-filter-container">
      {list.map((item) => (
        <div
          key={item.value}
          onClick={() => setRacingsState({ ...racingState, isYesterday: item.value })}
          className={classnames('filter-item', {
            active: item.value === isYesterday,
          })}
        >
          {t(item.label)}
        </div>
      ))}
    </div>
  );
};
